import React, { useState } from 'react';
import EventActionLogs from './EventActionLogs/EventActionLogs';
import PlayersMinuteLogs from './PlayersMinuteLogs/PlayersMinuteLogs';
import BoxScore from './BoxScore/BoxScore';
import Statistics from './Statistics/Statistics';
import IconCollection from '../../IconCollection/IconCollection';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';

const GameLogs = () => {
  const playersReducer = useSelector((state) => state?.playersReducer);
  const matchData = useSelector((state) => state?.playersReducer?.matchData);
  const game_data = useSelector((state) => state?.playersReducer?.matchData?.game_data);
  const [gameLogsTab, setGameLogsTab] = useState('EventActionLogs')
  const navigate = useNavigate();
    const goBack = () => {
    navigate(-1);
  };

  const renderGameLogsTab = () => {
    switch (gameLogsTab) {
      case 'EventActionLogs':
        return <EventActionLogs game_data={game_data} matchData={matchData} playersReducer={playersReducer} />;
      case 'PlayersMinuteLogs':
        return <PlayersMinuteLogs game_data={game_data} matchData={matchData} playersReducer={playersReducer} />;
      case 'BoxScore':
        return <BoxScore game_data={game_data} matchData={matchData} playersReducer={playersReducer} />;
      case 'Statistics':
        return <Statistics game_data={game_data} matchData={matchData} playersReducer={playersReducer} />;
      default:
        return <EventActionLogs game_data={game_data} matchData={matchData} playersReducer={playersReducer} />;
    }
  };

  return (
    <div>
      <div className=''>
           <div className='max-w-[1512px] w-full mx-auto px-6 md:px-12 h-20 flex justify-start items-center '>
        <button onClick={() => goBack()} className='flex justify-start items-center gap-2 cursor-pointer'>
          <IconCollection customClass='md:max-w-[25px] max-w-[10.16px] w-full md:h-[24px] h-[10.16px]' name="arrow-left" />
          <p className='text-xl font-montserrat font-medium text-[#4A4A4A]'>Back</p>
        </button>
      </div>
      <div className='w-full h-[1px] border-b-[1px] border-[#E8E8E8]'></div>
        <div className=' border-b-[1px] pt-[17px] border-[#E8E8E8] flex-col md:flex-row'>
          <div className='max-w-[1512px] px-12 mx-auto flex justify-center  items-center gap-5'>
            <button onClick={() => setGameLogsTab('EventActionLogs')} className={`font-rubik  capitalize ${gameLogsTab === 'EventActionLogs' ? 'text-primary font-medium hover:text-secondary border-b-[2px] border-primary' : 'text-[#7D7D7D] border-b-0 font-normal'} text-xl  py-3 px-5 cursor-pointer w-full md:w-auto text-center`}>
            Event Action Logs
          </button>
            <button onClick={() => setGameLogsTab('PlayersMinuteLogs')} className={`font-rubik  capitalize ${gameLogsTab === 'PlayersMinuteLogs' ? 'text-primary font-medium hover:text-secondary border-b-[2px] border-primary' : 'text-[#7D7D7D] border-b-0 font-normal'} text-xl  py-3 px-5 cursor-pointer w-full md:w-auto text-center`}>
            Players Minute Logs
          </button>
            <button onClick={() => setGameLogsTab('BoxScore')} className={`font-rubik capitalize  ${gameLogsTab === 'BoxScore' ? 'text-primary font-medium hover:text-secondary border-b-[2px] border-primary' : 'border-b-0 text-[#7D7D7D] font-normal'} text-xl  py-3 px-5 cursor-pointer w-full md:w-auto text-center`}>
            Boxscore
          </button>
            <button onClick={() => setGameLogsTab('Statistics')} className={`font-rubik capitalize  ${gameLogsTab === 'Statistics' ? 'text-primary font-medium hover:text-secondary border-b-[2px] border-primary' : 'border-b-0 text-[#7D7D7D] font-normal'} text-xl  py-3 px-5 cursor-pointer w-full md:w-auto text-center`}>
            Statistics.ai
          </button>
          </div>



        </div>
         <div className='max-w-[1512px] px-12 mx-auto' >
            {renderGameLogsTab()}
        </div>
      </div>
    </div>
  );
};

export default GameLogs;